import { getQuery } from "./UdasWrapper";
import { addErrorLog } from "Logger/logger";

export const fetchUsers = async (tenant_id) => {
  let data = JSON.stringify({
    query: `query Users($tenant_id: String!) {
      users(tenant_id: $tenant_id) {
        auth0_id
        tenant_id
        username
        user_type
        role_id
        status
        first_name
        last_name
        organization
        mobile
        phone
        email_address
        created_date_time
        language
        your_location
        image
      }
    }`,
    variables: { tenant_id },
  });
  try {
    const response = await getQuery(data);
    return response?.users;
  } catch (error) {
    addErrorLog("query Users", error, tenant_id);
    return null;
  }
};
